import React from 'react';
import SelectBox, { Item, SelectBoxProps } from '@/components/select/SelectBox';
import { countryCodes as defaultCountryCodes } from '@/config';
import { getCountryName } from '@/utils/locale/getCountryName';

type CountrySelectBoxProps<T extends Item> = SelectBoxProps<T> & {
  countryCodes?: string[];
};

export interface CountryItem {
  id: string;
  name: string;
}

const CountrySelectBox: React.FC<CountrySelectBoxProps<CountryItem>> = (props) => {
  const {
    label = 'Country:',
    placeholder = 'Select country',
    countryCodes = defaultCountryCodes,
  } = props;

  const listCountries = (): Promise<CountryItem[]> => {
    return new Promise((resolve) => {
      const items: CountryItem[] = countryCodes.map((countryCode) => {
        return {
          id: countryCode,
          name: getCountryName(countryCode) || countryCode,
        };
      });

      resolve(items);
    });
  };

  return (
    <SelectBox<CountryItem>
      {...props}
      name="country"
      label={label}
      placeholder={placeholder}
      queryFn={listCountries}
    />
  );
};

export default CountrySelectBox;
